import { Component, signal, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { I18nService } from '../../../../../core/services/i18n.service';
import { BlogService } from '../../services/blog.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { IPageInfo } from '../../../../../core/interfaces/interface';
import { SEOService } from '../../../../../core/services/seo.service';
import { IBlog } from '../../../home-page/interface';

@Component({
  selector: 'app-details',
  standalone: false,
  templateUrl: './details.component.html',
  styleUrl: './details.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class DetailsComponent {
  latestUpdate = new Date('2025,05,01');
  safeHtml = signal<SafeHtml>('');
  pageInfo = signal<IPageInfo>({} as any);
  blogList = signal<IBlog[]>([]);

  constructor(
    private activatedRoute: ActivatedRoute,
    private i18nService: I18nService,
    private blogService: BlogService,
    private sanitizer: DomSanitizer,
    private seoService: SEOService
  ) { }
  ngOnInit() {
    this.activatedRoute.params.subscribe(({ id }) => {
      this.getBostDetails(id)
      this.getBlogList(id)
    })
  }
  async getBlogList(id: any) {
    var blogList = await this.blogService.getBlogList(this.i18nService.language);
    var targetBlog = blogList.splice(blogList.findIndex(c => c.id == id), 1)[0];

    this.blogList.set(blogList);

    this.pageInfo.set({
      title: targetBlog!.title,
      jumbotronTitle: targetBlog!.title,
      image: targetBlog!.image_url,
      description: targetBlog.description,
      translated: true,
      isArticle: true
    });
    this.seoService.setPageSEO(this.pageInfo());
  }
  async getBostDetails(id: any) {
    var blog = (await this.blogService.getBostDetails(this.i18nService.language, id)) as any;
    this.safeHtml.set(
      this.sanitizer.bypassSecurityTrustHtml(
        blog
      ),
    );
  }
}